// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import { Analytics, tracingCallback } from '@trello/atlassian-analytics';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { ReopenBoardPopoverView } from 'app/scripts/views/board/ReopenBoardPopoverView';
import { Confirm } from 'app/scripts/views/lib/Confirm';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const reopen = function (this: any, e: any) {
  stopPropagationAndPreventDefault(e);
  const org = this.model.getOrganization();
  return (
    this.model
      .getNewBillableGuests()
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then(({ newBillableGuests, availableLicenseCount }: any) => {
        if (newBillableGuests.length > 0) {
          return PopOver.show({
            elem: $('.js-reopen', this.$el),
            // @ts-expect-error TS(2351): This expression is not constructable.
            view: new ReopenBoardPopoverView({
              board: this.model,
              org,
              newBillableGuests,
              availableLicenseCount,
            }),
          });
        } else {
          const traceId = Analytics.startTask({
            taskName: 'edit-board/closed',
            source: 'closedBoardScreen',
          });
          return this.model.reopen(
            { traceId },
            tracingCallback(
              {
                taskName: 'edit-board/closed',
                source: 'closedBoardScreen',
                traceId,
              },
              (err) => {
                if (!err) {
                  Analytics.sendTrackEvent({
                    action: 'reopened',
                    actionSubject: 'board',
                    source: 'closedBoardScreen',
                    containers: {
                      board: {
                        id: this.model.id,
                      },
                      organization: {
                        id: this.model.getOrganization()?.id,
                      },
                    },
                    attributes: {
                      taskId: traceId,
                    },
                  });
                }
              },
            ),
          );
        }
      })
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const _delete = function (this: any, e: any) {
  stopPropagationAndPreventDefault(e);

  return Confirm.toggle('delete board', {
    elem: e.target,
    model: this.model,
    confirmBtnClass: 'nch-button nch-button--danger',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fxConfirm: (e: any) => {
      const traceId = Analytics.startTask({
        taskName: 'delete-board',
        source: 'closedBoardScreen',
      });
      return this.model.startDelete(
        traceId,
        tracingCallback(
          {
            taskName: 'delete-board',
            source: 'closedBoardScreen',
            traceId,
          },
          (err) => {
            if (!err) {
              Analytics.sendTrackEvent({
                action: 'deleted',
                actionSubject: 'board',
                source: 'closeBoardScreen',
                containers: {
                  board: {
                    id: this.model.id,
                  },
                  organization: {
                    id: this.model.getOrganization()?.id,
                  },
                },
                attributes: {
                  taskId: traceId,
                },
              });
            }
          },
        ),
      );
    },
  });
};
